import React from "react";
import { Project } from "./Project";

export function Projects(props: { view: string }) {
  return (
    <div style={{ margin: "0px 5% 5%" }} id="projects" className="projects">
      <p>My Work</p>
      <hr
        style={{
          opacity: 0.5,
        }}
      />
      A few select projects I've worked on, for more you can check out my
      <a href="https://github.com/serge-21/" target="_blank" style={{}}>
        👉github
      </a>
      <div style={{ marginTop: "1rem" }} className={"Projects" + props.view}>
        <Project
          url="https://mondaylunch.club/"
          img="imgs/projects/gatos.webp"
          github="https://github.com/mondaylunch"
          description="An automation tool"
          languages={["Solid", "SpringBoot", "MongoDB", "Typescript"]}
        ></Project>

        <Project
          url=""
          img="imgs/projects/simulation.webp"
          github="https://github.com/serge-21/foxes-and-rabbits-handout"
          description="A predator prey simulation"
          languages={["Java", "JUnit", "JavaFX", "Maven"]}
        ></Project>

        <Project
          url=""
          img="imgs/projects/ITR.webp"
          github="https://github.com/serge-21/robotics-seach-program"
          description="A search program for a robotics enterprise"
          languages={["Python", "Smach", "ROS", "YOLO"]}
        ></Project>

        <Project
          url="https://serge21.pythonanywhere.com/"
          img="imgs/projects/MSMS.webp"
          github="https://github.com/serge-21/Dromedary"
          description="Music School Management System"
          languages={["Python", "Django", "HTML", "CSS", "Javascript"]}
        ></Project>
      </div>
    </div>
  );
}
